<template>
  <b-modal
    id="create-benefit-modal"
    ref="createModal"
    :title="`${benefit ? 'Update Benefit' : 'Create Benefit'}`"
    size="lg"
    hide-footer
    @shown="shownModal"
    @hidden="hiddenModal"
  >
    <validation-observer
      ref="formRef"
    >
      <b-form @submit.prevent="submitBenefit">
        <b-row>
          <!-- Name En -->
          <b-col md="6">
            <validation-provider
              name="Name En"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Name En"
                label-for="name-en"
              >
                <b-form-input
                  id="name-en"
                  v-model="form.name.en"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Name Ar -->
          <b-col md="6">
            <validation-provider
              name="Name Ar"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Name Ar"
                label-for="name-ar"
              >
                <b-form-input
                  id="name-ar"
                  v-model="form.name.ar"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Description En -->
          <b-col md="6">
            <validation-provider
              name="Description En"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Description En"
                label-for="desc-en"
              >
                <b-form-textarea
                  id="desc-en"
                  v-model="form.description.en"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Description Ar -->
          <b-col md="6">
            <validation-provider
              name="Description Ar"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Description Ar"
                label-for="desc-ar"
              >
                <b-form-textarea
                  id="desc-ar"
                  v-model="form.description.ar"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Benefit Type -->
          <!-- <b-col md="6">
            <validation-provider
              name="Benefit Type"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Benefit Type"
                label-for="benefit-type"
              >
                <b-form-select
                  id="benefit-type"
                  v-model="form.benefit_type"
                  :options="[
                    { text: 'Ride Discount', value: 'ride_discount' },
                    { text: 'Free Rides', value: 'free_rides' },
                    { text: 'Other', value: 'other' }
                  ]"
                  placeholder="Select Benefit Type"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col> -->

          <!-- Discount Percentage -->
          <b-col md="6">
            <validation-provider
              name="Discount Percentage"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Discount Percentage"
                label-for="discount-percentage"
              >
                <b-form-input
                  id="discount-percentage"
                  v-model.number="form.config.discount_percentage"
                  type="number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Rides Limit -->
          <b-col md="6">
            <validation-provider
              name="Rides Limit"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Rides Limit"
                label-for="rides-limit"
              >
                <b-form-input
                  id="rides-limit"
                  v-model.number="form.config.rides_limit"
                  type="number"
                  placeholder="e.g. 5"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Is Active"
              label-for="is-active"
            >
              <b-form-checkbox
                id="is-active"
                v-model="form.is_active"
                switch
              >
                {{ form.is_active ? 'Active' : 'Inactive' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Submit -->
        <div class="d-flex justify-content-end">
          <b-button
            :disabled="submitting"
            type="submit"
            variant="primary"
          >
            <b-spinner
              v-if="submitting"
              small
            />
            <span v-else>Submit</span>
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BFormTextarea,
  BButton, BSpinner, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import { successNotification, errorNotification } from '@/utils/toast-notifications'

const TEMP = {
  name: { en: '', ar: '' },
  description: { en: '', ar: '' },
  benefit_type: 'ride_discount',
  is_active: false,
  config: {
    discount_percentage: null,
    rides_limit: null,
  },
}

export default {
  components: {
    BModal,
    BFormCheckbox,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    // BFormSelect,
    BButton,
    BSpinner,
    BRow,
    BCol,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    benefit: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    const form = ref(JSON.parse(JSON.stringify(TEMP)))

    const formRef = ref(null)
    const submitting = ref(false)

    const submitBenefit = async () => {
      const valid = await formRef.value.validate()
      if (!valid) return
      try {
        submitting.value = true
        if (props.benefit) {
          await axiosIns.put(`/subscriptions/benefits/${props.benefit.id}`, form.value)
          successNotification('Benefit updated successfully')
        } else {
          await axiosIns.post('/subscriptions/benefits', form.value)
          successNotification('Benefit created successfully')
        }
        form.value = JSON.parse(JSON.stringify(TEMP))
        ctx.root.$bvModal.hide('create-benefit-modal')
        ctx.emit('done')
      } catch (err) {
        errorNotification('Failed to create benefit')
      } finally {
        submitting.value = false
      }
    }

    const shownModal = () => {
      if (props.benefit) {
        form.value = JSON.parse(JSON.stringify(props.benefit))
      }
    }
    const hiddenModal = () => {
      form.value = JSON.parse(JSON.stringify(TEMP))
    }
    return {
      hiddenModal,
      shownModal,
      form,
      submitting,
      submitBenefit,
      formRef,
      required,
    }
  },
}
</script>
